'use client';

import type { User as NextAuthUser } from 'next-auth';
import { useEffect } from 'react';

import { CONSENT_GROUP, consentGroupAllowed } from '~/lib/atom/analytics/client-consent';

declare global {
  interface Window {
    klaviyo?: {
      identify: (data: { email: string; first_name?: string; last_name?: string }) => void;
    };
  }
}

interface KlayvioIdentifyProps {
  user?: NextAuthUser;
}

export default function KlayvioIdentify({ user }: KlayvioIdentifyProps) {
  useEffect(() => {
    if (
      !user?.email ||
      typeof window === 'undefined' ||
      !window.klaviyo ||
      !consentGroupAllowed(CONSENT_GROUP.Targeting)
    ) {
      return;
    }

    const [firstName = '', lastName = ''] = (user.name || '').split(' ', 2);

    try {
      window.klaviyo.identify({
        email: user.email,
        first_name: firstName,
        last_name: lastName,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Klaviyo identification failed:', error);
    }
  }, [user?.email, user?.name]);

  return null;
}
